import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import LiberiumLink from "./LiberiumLink";

const SocialUserName = ({ user_id, color="black" }) => {
    const [name, setName] = useState("");
    const [error, setError] = useState(null);

    useEffect(() => {        
        const fetchUserData = async () => {            
            try {
                const userResponse = await sdk.models.PeupleUser.getOne(user_id);
                if (userResponse) {
                    setName(userResponse.first_name + " " + userResponse.last_name);
                } else {
                    setError("Utilisateur non trouvé");
                }
            } catch (err) {
                setError("Erreur lors de la récupération des données de l'utilisateur");
            }
        };
        if (user_id && user_id > 0)
            fetchUserData();
    }, [user_id]);

    return (
        <LiberiumLink href={"/user/" + user_id}>
            <span style={{ color }}>{name}</span>
        </LiberiumLink>
    );
};

export { SocialUserName };
